import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const SocietyHeader = ({ o, prev, count }) => {
  if (!o.society_name || (prev && prev.society_name === o.society_name && prev.tower === o.tower)) return null;
  return (
    <div className="mt-2 flex items-center justify-between rounded-xl bg-[#0F382C] px-3 py-2 text-sm text-white" data-testid={`society-header-${o.id}`}>
      <span className="font-semibold">{o.society_name}{o.tower ? ` · Tower ${o.tower}` : ""}</span>
      <span className="text-xs text-emerald-100">{count} flats</span>
    </div>
  );
};

export const BulkDeliverBar = ({ ids, onDone, onCancel }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const send = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("photo", file);
    fd.append("order_ids", ids.join(","));
    try {
      const r = await api.post("/deliveries/bulk-deliver", fd);
      toast.success(`${r.data.delivered} flats marked delivered`);
      if (r.data.errors.length) toast.error(`${r.data.errors.length} could not be delivered: ${r.data.errors[0].error}`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-[#E7E2D6] bg-white p-3 shadow-lg" data-testid="bulk-deliver-bar">
      <div className="mx-auto flex max-w-md gap-2">
        <Button variant="outline" onClick={onCancel} className="h-12" data-testid="bulk-cancel-btn">Cancel</Button>
        <Button disabled={!ids.length || busy} onClick={() => ref.current?.click()} className="h-12 flex-1 rounded-xl bg-[#0F382C] hover:bg-[#134E3A]" data-testid="bulk-deliver-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Camera className="mr-2 h-4 w-4" />Deliver {ids.length} selected (1 photo)</>}
        </Button>
        <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => send(e.target.files?.[0])} data-testid="bulk-photo-input" />
      </div>
    </div>
  );
};
